module.exports = __webpack_public_path__ + "img/the-lion-tamer.d91ab9e9.svg";